import{jsxs as t,jsx as e}from"react/jsx-runtime";import n from"styled-components";import{useTranslation as o}from"react-i18next";import s from"../../../../../assets/profileSettingsWhatsApp/android/add-contact-icon.svg.js";import{Wrapper as r}from"./styled.js";const i=n(r)`
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  align-items: center;
`,p=n.span`
  font-size: 14px;
  font-weight: 400;
`,a=()=>{const{t:n}=o();return t(i,{children:[e(p,{children:n("whatsapp.settings.businessAccount")}),e("img",{alt:"Android Add Contact Icon",src:s})]})};export{a as AccountSection};
//# sourceMappingURL=AccountSection.js.map
